import {
  FILTER_TREK,
  SET_LOADING_STATE,
  CLEAR_ALL_TREK_FILTER,
  ADD_TREK_FILTER_QUERY,
  REMOVE_TREK_FILTER_QUERY,
} from './types';

export const addQuery = query => ({
  type: ADD_TREK_FILTER_QUERY,
  query,
});

export const removeQuery = query => ({
  type: REMOVE_TREK_FILTER_QUERY,
  query,
});

export const filterTrek = data => ({
  type: FILTER_TREK,
  data,
});

export const clearAllFilters = () => ({
  type: CLEAR_ALL_TREK_FILTER,
});

export const setLoadingState = loading => ({
  type: SET_LOADING_STATE,
  loading,
});



// WEBPACK FOOTER //
// ./src/redux/actions/filterTreksActions.js